import { compose } from '@bem-react/core';
import { Textinput as TextinputBase } from '@yandex-int/hr-components/Textinput/desktop/bundle';
import { withDebounceInput } from '@yandex-lego/components/withDebounceInput';

export const Textinput = compose(
    withDebounceInput,
)(TextinputBase);
